// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

// Rxjs
import { Observable, forkJoin, of } from 'rxjs';

// formly
import { FormlyFieldConfig } from '@ngx-formly/core';
import { map } from 'rxjs/operators/map';
import { shareReplay } from 'rxjs/operators';

// Environment
import { environment } from 'environments/environment';

const httpOptionsJSON = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
    })
};

@Injectable()
export class LossAdjusterService {
    constructor(private http: HttpClient) { }

    public getFormData(): Observable<any> {
        return forkJoin([this.getFormModelProperty(), this.getFormFields()]);
    }

    public getFormModelProperty() {
        return Observable.of({
            Algemeen: {
                Dossiernummer: '',
                Opdrachtgever: '',
                Expert: '',
                Bezoekdatum: null,
                Spoedschade: false,
                Verzekeringnemer: 'Particulier',
                CoverageTC: ''
            },
            GegevensVerzekeringnemer: {
                GesprokenMet: '_',
                Initials: '',
                PrefixName: '',
                Name: '',
                Geboortedatum: null,
                Geboorteplaats: '',
                Legitimatie: '',
                Documentnummer: '',
                DocumentnummerVervaldatum: null,
                EmailAddress: '',
                Beroep: '',
                UitkeringPensioen: '',
                BurgelijkeStaat: '',
                KinderenInwonend: '_',
                BTWVerrekenbaar: 'Neen',
                IBANBankrekening: '',
                IBANTenNameVan: '',
                Gecontroleerdadhv: '_',
                GecontroleerdadhvAnders: '',
                GesprokenMetAnders: '',
                Partner: {
                    Initials: '',
                    PrefixName: '',
                    Name: '',
                    Geboortedatum: null,
                    Legitimatie: '',
                    Documentnummer: '',
                    DocumentnummerVervaldatum: null,
                    EmailAddress: '',
                    Beroep: '',
                    UitkeringPensioen: '',
                    BurgelijkeStaat: '',
                    KinderenInwonend: '_',
                    BTWVerrekenbaar: 'Neen',
                    IBANBankrekening: '',
                    IBANTenNameVan: '',
                    Gecontroleerdadhv: '_',
                    GecontroleerdadhvAnders: ''
                }
            },
            Verzekeringsverleden: {
                EerderSchadeGeleden: '_',
                VorigeVerzekeraars: 'n.v.t.',
                StrafrechterlijkVerleden: 'n.v.t.',
                VerzekerdBijOGSinds: ''
            },
            VerzekeringsGegevens: {
                SoortPolis: {
                    Opstal: false,
                    Inboedel: false,
                    Inventaris: false,
                    Goederen: false,
                    Anders: false
                },
                VerzekeringnemerIs: null,
                VerzekerdeSomOpstal: null,
                VerzekerdeSomOpstalControle: 'Niet gecontroleerd',
                VerzekerdeSomInboedel: null,
                VerzekerdeSomInboedelControle: 'Niet gecontroleerd',
                VerzekerdeSomInventaris: null,
                VerzekerdeSomInventarisControle: 'Niet gecontroleerd',
                VerzekerdeSomGoederen: null,
                VerzekerdeSomGoederenControle: 'Niet gecontroleerd',
                GewezenOpHetRechtVanContraExpertise: 'Ja',
                Hypotheekgegevens: 'N.v.t.',
                VerzekerdeWilContraExpertise: 'Neen',
                OverigeVerzekeringen: 'N.v.t.',
                CoAssurantie: 'N.v.t.',
            },
            RisicoOmschrijving: {
                SoortPand: 1,
                Bouwaard: '_',
                ZichBevindendeOpDe: '',
                TotaalAantalWoonlagen: '',
                BinnenEenVVE: '',
                WaarGesitueerd: '_',
                OnderhoudOpstal: 1,
                OnderhoudOpstalToelichting: '',
                OnderhoudInboedel: 1,
                OnderhoudInboedelToelichting: '',
                OnderhoudInventaris: 1,
                OnderhoudInventarisToelichting: '',
                Belendingen: 'Niet gevaarverhogend'
            },
            PreventieEnPolitieInformatie: {
                VanToepassing: 'Neen',
                BouwkundigePreventie: 'Voldoende',
                TypeAlarm: {
                    Magneetcontacten: false,
                    Infrarooddetectie: false,
                    Anders: false
                },
                AlarmInformatie: '',
                AlarmAanwezig: '_',
                Doormelding: '_',
                Resultaat: 'Neen',
                ToelichtingOpPV: 'Neen'
            },
            BrandweerEnSalvageInformatie: {
                VanToepassing: 'Neen',
                BrandweerTerPlaatse: 'Ja',
                SalvageIngeschakeld: '_'
            },
            Regres: {
                SchadeDoorAanrijdingMotorvoertuig: false,
                SchadeDoorOpzetMisdrijf: false,
                SchadeDoorHandelenOfNalatenVanAnderePartij: false,
                SchadeDoorGebruikVanOngeschiktOfGebrekkigMateriaalBijWerkzaamheden: false,
                Veroorzaker: {
                    Naam: '',
                    Adres: '',
                    PostcodeWoonplaats: '',
                    Telefoonnummer: '',
                    EmailAddress: '',
                    VerzekerdBij: '',
                    Kenteken: '',
                    Polisnummer: '',
                    MerkType: '',
                    Schadenummer: '',
                    Bestuurder: ''
                }
            },
            Afmetingen: {
                VanToepassing: false,
                Data: [
                ]
            },
            ToedrachtEnOorzaak: {
                Schadedatum: null,
                SchadedatumKlopt: true,
                SchadedatumCorrectie: null
            },
            Herstelbedrijf: {
                HerstellerIngeschakeld: 3
            },
            GegevensVerzekeringnemerZakelijk: {
                Rechtsvorm: '_',
                Gecontroleerdadhv: '_',
                StrafrechterlijkVerleden: 'n.v.t.',
                VorigeVerzekeraars: 'n.v.t.',
                EerderSchadeGeleden: '_',
                Geboortedatum: null,
                DocumentnummerVervaldatum: null
            }
        });
    }

    public getFormModelLiability() {
        return Observable.of({
            Algemeen: {
                Dossiernummer: '',
                Opdrachtgever: '',
                Expert: '',
                Bezoekdatum: null,
                Spoedschade: false,
                CoverageTC: ''
            },
            GegevensTegenpartij: {
                VanToepassing: false,
                Tegenpartij: 'Particulier',
                GesprokenMet: '_',
                Initials: '',
                PrefixName: '',
                Name: '',
                Geboortedatum: null,
                Geboorteplaats: '',
                Legitimatie: '',
                Documentnummer: '',
                DocumentnummerVervaldatum: null,
                EmailAddress: '',
                Beroep: '',
                UitkeringPensioen: '',
                BurgelijkeStaat: '',
                KinderenInwonend: '_',
                BTWVerrekenbaar: 'Neen',
                IBANBankrekening: '',
                IBANTenNameVan: '',
                Gecontroleerdadhv: '_',
                GecontroleerdadhvAnders: '',
                GesprokenMetAnders: '',
                Partner: {
                    Initials: '',
                    PrefixName: '',
                    Name: '',
                    Geboortedatum: null,
                    Legitimatie: '',
                    Documentnummer: '',
                    DocumentnummerVervaldatum: null,
                    EmailAddress: '',
                    Beroep: '',
                    UitkeringPensioen: '',
                    BurgelijkeStaat: '',
                    KinderenInwonend: '_',
                    BTWVerrekenbaar: 'Neen',
                    IBANBankrekening: '',
                    IBANTenNameVan: '',
                    Gecontroleerdadhv: '_',
                    GecontroleerdadhvAnders: ''
                }
            },
            GegevensTegenpartijZakelijk: {
                Rechtsvorm: '_',
                Gecontroleerdadhv: '_',
                GecontroleerdadhvAnders: '',
                StrafrechterlijkVerleden: 'n.v.t.',
                VorigeVerzekeraars: 'n.v.t.',
                EerderSchadeGeleden: '_',
                Geboortedatum: null,
                DocumentnummerVervaldatum: null,
            },
            GegevensVerzekeringnemer: {
                VanToepassing: false,
                Tegenpartij: 'Particulier',
                GesprokenMet: '_',
                Initials: '',
                PrefixName: '',
                Name: '',
                Geboortedatum: null,
                Geboorteplaats: '',
                Legitimatie: '',
                Documentnummer: '',
                DocumentnummerVervaldatum: null,
                EmailAddress: '',
                Beroep: '',
                UitkeringPensioen: '',
                BurgelijkeStaat: '',
                KinderenInwonend: '_',
                BTWVerrekenbaar: 'Neen',
                IBANBankrekening: '',
                IBANTenNameVan: '',
                Gecontroleerdadhv: '_',
                GecontroleerdadhvAnders: '',
                GesprokenMetAnders: '',
                Partner: {
                    Initials: '',
                    PrefixName: '',
                    Name: '',
                    Geboortedatum: null,
                    Legitimatie: '',
                    Documentnummer: '',
                    DocumentnummerVervaldatum: null,
                    EmailAddress: '',
                    Beroep: '',
                    UitkeringPensioen: '',
                    BurgelijkeStaat: '',
                    KinderenInwonend: '_',
                    BTWVerrekenbaar: 'Neen',
                    IBANBankrekening: '',
                    IBANTenNameVan: '',
                    Gecontroleerdadhv: '_',
                    GecontroleerdadhvAnders: ''
                }
            },
            GegevensVerzekeringnemerZakelijk: {
                Rechtsvorm: '_',
                Gecontroleerdadhv: '_',
                StrafrechterlijkVerleden: 'n.v.t.',
                VorigeVerzekeraars: 'n.v.t.',
                EerderSchadeGeleden: '_',
                Geboortedatum: null,
                DocumentnummerVervaldatum: null
            },
            RelatieTussenPartijen: {
                HoedanigheidVeroorzaker: '_'
            },
            VerzekeringsgegevensTegenpartij: {
                SoortPolis: {
                    Opstal: false,
                    Inboedel: false,
                    InventarisGoederen: false,
                    Anders: false
                },
                GemeldBijEigenVerzekeraar: '_',
                SchadenummerBekend: '_',
                InBehandelingGenomen: '_',
                GeadviseerdDitAlsnogTeDoen: '_'
            },
            ToedrachtEnOorzaak: {
                Schadedatum: null,
                SchadedatumKlopt: true
            },
            Aansprakelijkstelling: {
                SchadeDoor: '_'
            },
            GegevensSchadeveroorzaker: {
                VanToepassing: false,
                Geboortedatum: null,
            },
            GegevensMotorvoertuig: {
                VanToepassing: false
            },
            AlgemeneEOLeveringsvoorwaarden: {
                VanToepassing: false
            },
            Afmetingen: {
                VanToepassing: false,
                Data: [
                ]
            }
        });
    }

    public getFormFields(formName: string = 'property-form.json') {
        return this.http
            .get<FormlyFieldConfig[]>('assets/forms/' + formName)
            .pipe(shareReplay(1));
    }

    public getFormModel(caseID: string): Observable<any> {
        const sUrl = environment.Services.BacklogURL + 'backlog/' + caseID;

        return this.http
            .get(sUrl)
            .pipe(
                map(data => {
                    if (data && data['JsonEntryForm']) {
                        const jsonEntryForm = JSON.parse(data['JsonEntryForm']);

                        return jsonEntryForm;
                    } else {
                        return null;
                    }
                })
            );
    }

    public getFormType(caseID: string): Observable<any> {
        const sUrl = environment.Services.BacklogURL + 'backlog/' + caseID;

        return this.http
            .get(sUrl)
            .pipe(
                map(data => {
                    if (data && data['BacklogItemType']) {
                        const backlogItemType = data['BacklogItemType'];

                        return backlogItemType;
                    } else {
                        return null;
                    }
                })
            );
    }

    public getUniversalCalculationData(caseID: string): Observable<any> {
        const sUrl = environment.Services.BacklogURL + 'unibrand/' + caseID;

        return this.http
            .get(sUrl)
            .pipe(
                map(data => {
                    if (data && data['UniversalCalculation']) {
                        let universalCalculation = [];

                        try {
                            universalCalculation = JSON.parse(data['UniversalCalculation']);
                        } catch (e) {
                            if (e instanceof SyntaxError) {
                                this.printError(e, true);
                            } else {
                                this.printError(e, false);
                            }
                        }

                        return universalCalculation;
                    } else {
                        return [];
                    }
                })
            );
    }

    public getSignature(caseID: string): Observable<any> {
        const sUrl = environment.Services.BacklogURL + 'signature/' + caseID;

        return this.http
            .get(sUrl)
            .pipe(
                map(data => {
                    if (data) {
                        return data;
                    } else {
                        return {};
                    }
                })
            );
    }

    public saveSignature(caseID: string, signatureSVG: string, experEmailAddress: string): Observable<any> {
        const sUrl = environment.Services.BacklogURL + 'signature/' + caseID;
        const vm: any = {
            CaseID: caseID,
            ExpertEmailAddress: experEmailAddress,
            SignatureSVG: signatureSVG
        };

        return this.http
            .post(sUrl, vm, httpOptionsJSON)
            .retry(0)
            .pipe(map(resp => {
                return resp;
            }));
    }

    public saveFormModel(caseID: string, jsonEntryForm: any, experEmailAddress: string, caseBacklogType: string): Observable<any> {
        const sUrl = environment.Services.BacklogURL + 'createcasebacklog';

        const vm: any = {
            CaseID: caseID,
            JsonEntryForm: JSON.stringify(jsonEntryForm),
            ExpertEmailAddress: experEmailAddress,
            CaseBacklogType: caseBacklogType
        };

        return this.http
            .post(sUrl, vm, httpOptionsJSON)
            .retry(0)
            .pipe(map(resp => {
                return resp;
            }));
    }

    public saveUniBrand(caseID: string, uniBrandData: any, experEmailAddress: string): Observable<any> {
        const sUrl = environment.Services.BacklogURL + 'unibrand/' + caseID;

        const vm: any = {
            CaseID: caseID,
            uniBrandData: JSON.stringify(uniBrandData),
            ExpertEmailAddress: experEmailAddress
        };

        return this.http
            .post(sUrl, vm, httpOptionsJSON)
            .pipe(map(resp => {
                return resp;
            }));
    }

    private printError(error, explicit) {
        console.log(`[${explicit ? 'EXPLICIT' : 'INEXPLICIT'}] ${error.name}: ${error.message}`);
    }
}
